export class PickActions {
    static ActionSpot: string = "SPOT_";
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/Channels/Common/Actions/PickActions.ts
 **/